import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import ImageGallery from './ImageGallery';

const ExperienceSection: React.FC = () => {
  const { translations, language } = useLanguage();
  
  // Gallery images mit absoluten Pfaden, die auf das images-Verzeichnis im öffentlichen Ordner verweisen
  const galleryImages = [
    '/images/SeaDent Gallery 1.jpg',
    '/images/SeaDent Gallery 2.jpg',
    '/images/SeaDent Gallery 3.jpg',
    '/images/SeaDent Gallery 4.jpg',
    '/images/SeaDent Gallery 5.jpg'
  ];

  // Accessibility alt text in different languages
  const altTexts = {
    de: "SeaDent Mallorca Praxisimpressionen",
    en: "SeaDent Mallorca clinic impressions",
    es: "Impresiones de la clínica SeaDent Mallorca",
    ru: "Впечатления о клинике SeaDent Майорка"
  };
  
  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50" id="experience">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-navy mb-4">{translations.experience.title}</h2>
          <p className="max-w-3xl mx-auto text-gray-800 mb-6">
            {translations.experience.text}
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Gallery now takes full width on mobile for better visibility */}
          <div className="order-2 md:order-1 md:col-span-1 relative">
            <ImageGallery 
              images={galleryImages} 
              interval={5000}
              className="h-[450px] shadow-2xl rounded-lg overflow-hidden"
              altText={altTexts[language]}
            />
          </div>
          
          <div className="order-1 md:order-2 md:col-span-1">
            <ul className="space-y-6 text-gray-800">
              {translations.experience.points.map((point, index) => (
                <li key={index} className="flex items-start">
                  <div className="text-light-blue mr-4 flex-shrink-0 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <span className="text-lg">{point}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection; 